import React, { useEffect, useRef } from "react"
import { motion, AnimatePresence } from "framer-motion"

const Modal = ({ children, id, ariaLabel, show, handleClose }) => {
  const modalContent = useRef(null)

  // close the modal on click outside
  useEffect(() => {
    const clickHandler = ({ target }) => {
      if (!show || modalContent.current.contains(target)) return
      handleClose()
    }
    document.addEventListener("click", clickHandler)
    return () => document.removeEventListener("click", clickHandler)
  })

  // close the modal if the esc key is pressed
  useEffect(() => {
    const keyHandler = ({ keyCode }) => {
      if (keyCode !== 27) return
      handleClose()
    }
    document.addEventListener("keydown", keyHandler)

    return () => document.removeEventListener("keydown", keyHandler)
  })

  return (
    <>
      <AnimatePresence>
        {show && (
          // Use motion.div for the backdrop animation
          <motion.div
            className={"fixed top-0 left-0 w-full h-full bg-navy-950 z-[9998]"}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            {/* Render the modal with animation */}
            <div
              className={
                "fixed w-full max-w-[1280px] top-1/2 left-1/2 transform -translate-y-1/2 -translate-x-1/2 p-2 bg-white border-4 border-blue z-[9999]"
              }
              ref={modalContent}
            >
              {children}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  )
}

export default Modal
